import * as React from 'react';
import { GroupServiceGetManyResponse, GroupServiceGetResponse } from '../../services/api';
import { groupIsAssignedToCurrentUser } from '../../utils/groupList';
import { useAppSelector } from '../../store';

export default function GroupAssignedTo({ group }: { group: GroupServiceGetManyResponse | GroupServiceGetResponse }) {
  const { user } = useAppSelector((state) => state.auth);

  if (!group.assignedTo) return null;

  return (
    <div className="flex items-center gap-1 text-sm text-grey-8">
      <span className="pi pi-user"></span>
      <span><strong>Assigned to:</strong> {groupIsAssignedToCurrentUser(group, user) ? 'YOU' : group.assignedTo}</span>
    </div>
  )
}